import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import db from "./db"
import CircularProgress from '@material-ui/core/CircularProgress';

var jb = false
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
});

var words = "Exercise"

class Board extends React.Component{

    componentWillMount(){
        db.ref("data").on("value",(data)=>{
           
                this.renderData()
                this.setState({
                    img:data.val(),
                    sensitive:data.val().texts.includes(words)
                })

                console.log(this.state)
        
         
        })
    }

    renderData = () =>{
        this.setState({
            loading:true
        })

        setTimeout(()=>{
            this.setState({
                loading:false
            })
        },3500)
       
    }

    renderText =() =>{
      if(this.state.loading){
        return  <div></div>
      }else {
        

        if(this.state.img.texts){
          
          return <p  style={{textAlign:"left"}}>{this.state.img.texts}</p>
        }else{
          return <p>No text detected in the image!</p>
        }

       
      }
        
    }

    renderData(){

    }

    state = {
        img:"",
        sensitive:false
    }
    render(){
        const { classes } = this.props;

        return (
            <div className={classes.root}>
              <Grid container spacing={24} style={{padding:20}}>
               
                <Grid item xs={12} md={6}>
                  <Paper className={classes.paper}>
                    {this.state.loading?
                            <CircularProgress />
                            :
                            <img src={this.state.img.imgUrl} alt='scaned image' style={{height:"80vh"}}/>}
                
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper className={classes.paper} style={{height:"80vh"}}>
                  {this.state.loading?
                    <CircularProgress />
                    :
                    this.state.img.status==="1"?<h3>The paper is reuseable</h3>:<h3>The paper is recycled</h3>}
                    
                    {this.state.sensitive && <h3 style={{color:"red"}}>The paper contains sensitive information:{words}</h3>}

                    {this.renderText()}
                   


                  </Paper>
                </Grid>
                
              </Grid>
            </div>
          ); 
    }


 
}


export default withStyles(styles)(Board);
